class SlideshowComponent extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
    this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
    this.current = 0;

    const prevButton = this.querySelector('[data-slide-prev]');
    const nextButton = this.querySelector('[data-slide-next]');

    if (prevButton) prevButton.addEventListener('click', () => this.go(this.current - 1));
    if (nextButton) nextButton.addEventListener('click', () => this.go(this.current + 1));

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.go(index));
    });

    if (this.slides.length > 1 && this.dataset.autoplay === 'true') {
      this.autoplaySpeed = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;
      this.#startAutoplay();
      this.addEventListener('mouseenter', () => this.#stopAutoplay());
      this.addEventListener('mouseleave', () => this.#startAutoplay());
    }
  }

  disconnectedCallback() {
    this.#stopAutoplay();
  }

  go(index) {
    const total = this.slides.length;
    if (total === 0) return;

    this.current = (index + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.current);
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }

  #startAutoplay() {
    this.#stopAutoplay();
    this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySpeed);
  }

  #stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }
}

if (!customElements.get('slideshow-component')) {
  customElements.define('slideshow-component', SlideshowComponent);
}
